const LAYOUT = {
  GAP: 18,
  GUTTER: 24,
  HEADER_HEIGHT: 30,
  FONT_SMALL: 12,
};

export default LAYOUT;
